var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTutorialMenuStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 149,
    height: 134,
    viewBox: "0 0 149 134",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_7449_363017)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.5 12L76.9996 61.9337L98.4177 16.7575L81.6182 63.8468L118.694 30.3058L85.1532 67.3818L132.242 50.5823L87.0663 72.0004L137 74.5L87.0663 76.9996L132.242 98.4177L85.1532 81.6182L118.694 118.694L81.6182 85.1532L98.4177 132.242L76.9996 87.0663L74.5 137L72.0004 87.0663L50.5823 132.242L67.3818 85.1532L30.3058 118.694L63.8468 81.6182L16.7575 98.4177L61.9337 76.9996L12 74.5L61.9337 72.0004L16.7575 50.5823L63.8468 67.3818L30.3058 30.3058L67.3818 63.8468L50.5823 16.7575L72.0004 61.9337L74.5 12Z",
    fill: "#0BC4F9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_7449_363017",
    x: 0,
    y: 0,
    width: 149,
    height: 149,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6,
    result: "effect1_foregroundBlur_7449_363017"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTutorialMenuStar);
export default __webpack_public_path__ + "static/media/tutorial-menu-star.b7dd066531dbc72cc362ffe980efb6fb.svg";
export { ForwardRef as ReactComponent };